import { RGB8 } from "@/keyboard/keyboard_config";

export const rgb8AsDict = (c: RGB8) => ({ r: c[0], g: c[1], b: c[2] });
export const rgb8AsArray = (c: {
  r: number;
  g: number;
  b: number;
}): [number, number, number] => [c.r, c.g, c.b];
